













































































import Vue, { PropType } from 'vue';
import { Cv, CvSectionProfile, CvSectionProfileSexEnum } from '@/../gen';
import SectionPreviewField from '@/components/section-preview/SectionPreviewField.vue';
import dayjs from 'dayjs';
import { i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionPreviewField,
  },
  filters: {
    moment: function(date) {
      return dayjs(date).format('YYYY/MM/DD');
    },
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    profile: {
      type: Object as PropType<CvSectionProfile>,
      required: true,
    },
  },
  methods: {
    convertSexI18n(value: string) {
      return this.$i18n.tc(i18nHints.models.cv_section_profile.sexes[value]);
    },
    isShowSex(profile: CvSectionProfile) {
      return [
        CvSectionProfileSexEnum.Male,
        CvSectionProfileSexEnum.Female,
      ].includes(profile.sex);
    },
  },
});
